// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-content-renderer {
  padding: 16px;
  margin-bottom: 24px;
}

.description {
  margin-bottom: 16px;
}

.description b {
  font-weight: bold;
  color: #1890ff;
}
`, "",{"version":3,"sources":["webpack://./src/components/ApiDocsViewer/DiscriptionSection/discriptionSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".dynamic-content-renderer {\n  padding: 16px;\n  margin-bottom: 24px;\n}\n\n.description {\n  margin-bottom: 16px;\n}\n\n.description b {\n  font-weight: bold;\n  color: #1890ff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
